module.exports = __webpack_public_path__ + "static/vector-shape3-e9c80b27ba4eeb36edf08c1ce5bfc21b.png";